import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookieBanner from "@/components/CookieBanner";
import { SITE } from "@/lib/site";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App font-inter antialiased text-[#1A2B56] bg-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path={SITE.privacyPath} element={<PrivacyPolicy />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
